import { type ReactElement } from 'react';
import styles from './style.module.scss';

const VerticalDivider = (): ReactElement => {
  return <div className={styles.container} />;
};

export default VerticalDivider;
